import { createAction, props } from '@ngrx/store';

export const triggerAddAction = createAction(
  '[Continue-conv] Trigger AddAction',
    props<{
      triggerAddActionFlag: boolean;
    }>()
);